import React from "react";

const QuotationItems = ({ quotation }) => {
  const lines = quotation?.lines || [];

  const formatCurrency = (amount) => {
    if (amount === null || amount === undefined || amount === "") {
      return "-";
    }

    return `${quotation?.currencySymbol || ""}${Number(amount).toFixed(2)}`;
  };

  return (
    <section className="quotation-card">
      <h2>Quotation Details</h2>

      <div className="quotation-table-wrapper">
        <table className="quotation-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Description</th>
              <th>Unit</th>
              <th>Qty</th>
              <th>Unit Price</th>
              <th>Total</th>
            </tr>
          </thead>

          <tbody>
            {lines.length > 0 ? (
              lines.map((line, index) => (
                <tr key={line.id}>
                  <td>{index + 1}</td>

                  <td>
                    <div className="item-description">
                      <strong>{line.description || "-"}</strong>

                      {line.details && (
                        <span>{line.details}</span>
                      )}
                    </div>
                  </td>

                  <td>{line.unit || "-"}</td>

                  <td>{line.quantity ?? "-"}</td>

                  <td>{formatCurrency(line.unitPrice)}</td>

                  <td>
                    <strong>
                      {formatCurrency(line.lineTotal)}
                    </strong>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6">
                  No quotation items available.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="quotation-totals">
        <div className="totals-row">
          <span>Subtotal</span>

          <strong>
            {formatCurrency(quotation?.subtotal)}
          </strong>
        </div>

        {Number(quotation?.discount || 0) > 0 && (
          <div className="totals-row discount-row">
            <span>Discount</span>

            <strong>
              -{formatCurrency(quotation?.discount)}
            </strong>
          </div>
        )}

        <div className="totals-row">
          <span>
            {quotation?.taxLabel || "VAT"} (
            {quotation?.taxRate || 0}%)
          </span>

          <strong>
            {formatCurrency(quotation?.taxAmount)}
          </strong>
        </div>

        <div className="totals-row total-row">
          <span>Total</span>

          <strong>
            {formatCurrency(quotation?.totalAmount)}
          </strong>
        </div>
      </div>
    </section>
  );
};

export default QuotationItems;